import { render, staticRenderFns } from "./t-faq.vue?vue&type=template&id=70c51094&scoped=true&"
import script from "./t-faq.vue?vue&type=script&lang=js&"
export * from "./t-faq.vue?vue&type=script&lang=js&"
import style0 from "@/css/Main_style.scss?vue&type=style&index=0&id=70c51094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c51094",
  null
  
)

export default component.exports